class ProductSwatchesWrapper extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      swatchLinksWrapper: '[js-swatch-links-wrapper]',
      swatchLink: '[js-swatch-link]'
    };
  }

  connectedCallback() {
    this.swatchLinksWrappers = this.querySelectorAll(this._selectors.swatchLinksWrapper);
    
    if (this.swatchLinksWrappers.length > 0) {
      this._initSwatchLinks();
    }
  }

  _popStateRender = () => {
    this._renderSwatchLink(document.location, false)
  }

  _renderSwatchLink = (url, pushState) => {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const oldMain = document.querySelector('.product-information');
        const newMain = html.querySelector('.product-information');

        const oldProductRecommendations = document.querySelector('.product-recommendations-section');
        const newProductRecommendations = html.querySelector('.product-recommendations-section');
        
        oldMain.innerHTML = newMain.innerHTML;
        oldProductRecommendations.innerHTML = newProductRecommendations.innerHTML;
        this.dataset.handle = newMain.dataset.handle;

        if (pushState === true) {
          window.history.pushState({}, "", url);
        }

        window.removeEventListener('popstate', this._popStateRender);

        this.connectedCallback();    
      })
      .catch((e) => {
        console.error(e);
      });
  }

  _swatchLinkOnClick = (evt) => {
    evt.preventDefault();

    const url = evt.currentTarget.href;
    this._renderSwatchLink(url, true);
  }

  _handleSwatchLinks = () => {
    this.swatchLinks = this.querySelectorAll(this._selectors.swatchLink);

    if (this.swatchLinks.length < 1) {
      return;
    }

    this.swatchLinks.forEach((swatchLink) => {
      swatchLink.addEventListener('click', this._swatchLinkOnClick);
    });
  }

  _getRelatedProductsJSON = (url) => {
    const results = fetch(url)
      .then(response => response.text())
      .then((text) => {
        const html = text;
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        const JSONcontainer = parsedHTML.querySelector('[js-products-json]');
        const parsedJSON = JSON.parse(JSONcontainer.innerHTML);
        return parsedJSON;
      });
    return results;
  }

  _initSwatchLinks = () => {
    const init = async () => {
      const tag = this.swatchLinksWrappers[0].dataset.tag;
      const targetURL = `${window.Shopify.routes.root}collections/all-products/${tag}?view=json`;
      const products = await this._getRelatedProductsJSON(targetURL);   
      
      this.swatchLinksWrappers.forEach((container) => {
        let swatchLinksMarkup = '';

        products.forEach((product) => {
          const swatchStyle = product.colorImg && product.colorImg != ''
          ? `background-image: url(${product.colorImg}); background-size: cover; background-position: center;`
          : `background-color: ${product.colorHex};`;
          if (this.dataset.handle == product.handle) {
            swatchLinksMarkup = `${swatchLinksMarkup}
                              <div class="product__swatch-link product__swatch-link--current" aria-labelledby="${product.colorTitle}">
                                <span class="product__related-color" style="${swatchStyle}"></span>
                              </div>`;
          } else {
            swatchLinksMarkup = `${swatchLinksMarkup}
                              <a href="${product.url}" class="product__swatch-link" aria-labelledby="${product.colorTitle}" data-value="${product.colorTitle}" js-swatch-link>
                                <span class="product__related-color" style="${swatchStyle}"></span>
                              </a>`;
          }
      });

        container.innerHTML = swatchLinksMarkup;
        container.dataset.loaded = 'true';
      });

      this._handleSwatchLinks();
    }

    init();
  }
}

customElements.define('product-swatches-wrapper', ProductSwatchesWrapper);